import { ELayoutsActionTypes } from '../../actions/layouts';
import { ILayouts } from '../../types/newbuilding/layouts';
import { TReduxActions } from '../../types/redux';

export function layoutsReducer(state: ILayouts | null = null, action: TReduxActions): ILayouts | null {
  if (state !== null) {
    switch (action.type) {
      case ELayoutsActionTypes.SelectHouseId:
        return {
          ...state,
          selectedHouseId: action.payload,
        };
      case ELayoutsActionTypes.SelectRoomsCount:
        return {
          ...state,
          selectedRoomsCount: action.payload,
        };
      case ELayoutsActionTypes.SetLayoutsData:
        return {
          ...state,
          selectedRoomsCount: action.payload.roomsCount,
          selectedHouseId: action.payload.houseId,
          data: action.payload.data || undefined,
        };
      default:
        return state;
    }
  }

  return null;
}
